import scrollTo from './scrollTo';
import ResizeTracker from 'utils/ResizeTracker';

class ScrollTabs {

    /**
     * Make a new Scroll trigger.
     * @constructs
     * @param {HTMLElement} element
     * @param {{}} options
     */
    constructor() {
        this._options = {
            offset: 80,
            mobileSize: 768,
            timeout: 350
        };

        this._state = {
            isMobile: false
        };

        this._rootContainer = document.body;
        this._setIsMobile = this._setIsMobile.bind(this);
        this._cacheSelectors();
        this._initialize();
    }

    /**
     * Initialize
     * @private
     */
    _cacheSelectors() {
        this._elements = [...this._rootContainer.querySelectorAll('[data-scroll]')];
        this._header = this._rootContainer.querySelector('.header');
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {
        this._resizeTracker = new ResizeTracker();

        this._resizeTracker.init(
            { element: this._rootContainer },
            this._setIsMobile
        );

        this._setIsMobile();

        if (this._elements) {
            this._elements.forEach(targetElement => {
                targetElement.addEventListener('click', event => {
                    const timeout = setTimeout(() => {
                        const targetBoundingBox = targetElement.getBoundingClientRect();
                        const offset = targetBoundingBox.top + document.documentElement.scrollTop - this._header.clientHeight - this._options.offset;
                        // eslint-disable-next-line no-unused-expressions
                        this._state.isMobile && scrollTo(event, offset);
                        clearTimeout(timeout);
                    }, this._options.timeout);
                });
            });
        }
    }

    /**
     * Set mobile state
     * @private
     */
    _setIsMobile() {
        this._state.isMobile = this._rootContainer.clientWidth < this._options.mobileSize;
    }
}

export default ScrollTabs;
